__webpack_require__.p = "https://cdn-vn.mygobiz.net/gobiz-amphitrite/4.1210.1115.RELEASE/";